import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import COLORS from "../Utils/colors";
import GridWrapper from "../Components/GridWrapper";

// SVG icons
import { ReactComponent as HomeIcon } from "../Icons/svg/home.svg";
import { ReactComponent as PlacesIcon } from "../Icons/svg/places.svg";
import { ReactComponent as TripsIcon } from "../Icons/svg/trips.svg";
import { ReactComponent as PostIcon } from "../Icons/svg/post.svg";
import { ReactComponent as ShortsIcon } from "../Icons/svg/shorts.svg";

const navItems = [
  { label: "Home", icon: HomeIcon, path: "/" },
  { label: "Trips", icon: TripsIcon, path: "/trips" },
  { label: "Posts", icon: PostIcon, path: "/post" },
  { label: "Shorts", icon: ShortsIcon, path: "/shorts" },
  { label: "Places", icon: PlacesIcon, path: "/allplaces" },
];

export default function FixedBottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showNav, setShowNav] = React.useState(true);
  const [lastScrollY, setLastScrollY] = React.useState(() => window.scrollY);

  const currentPath = location.pathname.toLowerCase();
  const isNavRoute = navItems.some((item) => item.path.toLowerCase() === currentPath);

  const handleNavClick = React.useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate]
  );

  if (!isNavRoute) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        minWidth: "320px",
        zIndex: 1000,
        // transition: "bottom 0.3s ease-in-out",
        paddingBottom: "env(safe-area-inset-bottom)",
        backgroundColor: "transparent",
      }}
    >
      <GridWrapper>
        <nav
          style={{
            width: "100%",
            maxWidth: "100%",  // Add this
            backgroundColor: "#ffffff",
            boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.15)",
            borderRadius: "0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 4px",
            minHeight: "64px",
            boxSizing: "border-box",
          }}
        >
          {navItems.map((item, index) => {
            const IconComponent = item.icon;
            const isActive = currentPath === item.path.toLowerCase();
            
            return (
              <button
                key={index}
                onClick={() => handleNavClick(item.path)}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                  // backgroundColor: isActive ? COLORS.primary : "transparent",
                  backgroundColor:'transparent',
                  border: "none",
                  cursor: "pointer",
                  // padding: isActive ? "6px 0" : "8px 4px",
                  minWidth: 0,
                  // width: isActive ? "56px" : "auto",
                  // height: isActive ? "32px" : "auto",
                  opacity: 1,
                  // transition: "background-color 0.3s ease, color 0.3s ease, width 0.3s ease, height 0.3s ease, border-radius 0.3s ease",
                  WebkitTapHighlightColor: "transparent",
                }}
                aria-label={item.label}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "20px",
                    height: "20px",
                  }}
                >
                  <IconComponent
                    style={{
                      width: "20px",
                      height: "20px",
                      fill: isActive ? COLORS.primary : "#7a7485",
                      // transition: "fill 0.3s ease",
                    }}
                  />
                </div>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight:  400,
                    lineHeight: "1.2",
                    color: isActive ? COLORS.primary : "#7a7485",
                    // transition: "color 0.3s ease, font-weight 0.3s ease",
                  }}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>
      </GridWrapper>
    </div>
  );
}
